module.exports = __webpack_public_path__ + "static/media/Slide6.86eab785.jpeg";